<template>
    <my-carousel
        :per-page-custom="[[0, 1], [768, 2], [991, 2], [1100, 3], [1200, 4]]"
        :pagination-enabled="true"
        :scroll-per-page="true"
        :navigation-enabled="true"
        :navigation-next-label="'<span></span>'"
        :navigation-prev-label="'<span></span>'"
        ref="home_news"
    >
        <slide v-for="(item, key) in news" :key="key">
            <div v-if="config.template == 1" class="carousel-card d-flex flex-column">
                <div>
                    <h4>{{ item.title }}</h4>
                </div>

                <div v-html="item.description"></div>

                <div class="mt-auto">
                    <a :href="item.url_href" target="_blank">
                        {{ lang.news.more }}
                    </a>
                </div>

                <!-- <div class="mx-auto">
                    <img :src="item.img_url" :alt="item.title" class="card-news mx-auto d-block" width="220" height="220">
                </div> -->
            </div>

            <div v-else-if="config.template == 2" class="carousel-card d-flex flex-column">
                <!-- <h2>{{ trans('home.services.title_news') }}</h2> -->
                <div class="mx-auto">
                    <img :src="item.img_url" :alt="item.title" class="card-news mx-auto d-block">
                </div>
                <div>
                    <h4>{{ item.title }}</h4>
                </div>
                <div v-html="item.description"></div>

                <div class="mt-auto">
                    <a :href="item.url_href" target="_blank">
                        {{ lang.news.more }}
                    </a>
                </div>

            </div>

            <div v-else-if="config.template == 3" class="carousel-card d-flex flex-column">
                <div class="img">
                    <img :src="item.img_url" :alt="item.title" class="card-news mx-auto d-block">
                </div>
                <div class="title">
                    <h4>{{ item.title }}</h4>
                </div>

                <div v-html="item.description" class="description"></div>

                <div class="subdescription" v-if="item.options.length">
                   <div :class="option_classes[key]" v-for="option in item.options">
                        <a
                            v-if="option.is_public && isValidURL(option.url)"
                            :href="option.url"
                            target="blank"
                        >
                            {{option.title}}
                        </a>
                    </div>
                </div>

                <!-- <div class="mt-auto">
                    <a :href="item.url_href" target="_blank">
                        {{ lang.news.more }}
                    </a>
                </div> -->

            </div>

        </slide>
    </my-carousel>
</template>

<script>
import MyCarousel from './MyCarousel'

export default {
    components: {
        'my-carousel': MyCarousel,
    },

    props: {
        config: {
            type: Object,
            required: true,
        }
    },

    computed: {
        lang() {
            return this.$root.lang.home
        },
    },

    data() {
        return {
            news: [],
            option_classes: {
                0: 'link',
                1: 'video',
                2: 'video',
                3: 'video'
            }
        }
    },

    mounted() {
        axios.get('/api/news')
            .then(({data}) => {
                this.news = data

                this.news.forEach((item, key) => {
                    item.img_url = this.config.img[key]
                    item.url_href = item.url
                })
            })
    },

    methods:{
        isValidURL(url) {
            let urlRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;

            return urlRegex.test(url);
        }
    }
}
</script>
